import React, { useEffect, useState } from 'react'
import { getAllAttributes, getAllListings, getEventsByListingId } from '../utils';
import ListingsWithFilters from '../ListingsWithFilters';
import FloatingButtons from '../frontend/FloatingButtons';
export default function Listings() {

    // Sample columns
    const columns = [
        { Header: 'ID', accessor: 'id' },
        { Header: 'Name', accessor: 'name' },
        { Header: 'Price', accessor: 'price' },
        { Header: 'backgroundImage', accessor: 'backgroundImage' },
        { Header: 'location', accessor: 'location' },
        // ... more columns
      ];

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [])

    const [listings, setListings] = useState([]);
    const [transformedData, setTransformedData] = useState([]);

    const fetchListings = async () => {
      try {
        const listings = await getAllListings();
        setListings(listings);
  
        const transformedDataRaw = listings.map((listing) => {
          if (listing.boatStatus === 'Active') {
            return {
              id: String(listing.id),
              name: listing.listingTitle || '',
              price: '',
              backgroundImage: listing.featured_image || '',
              selectedAttributes: listing.features || [],
              location: listing.storageAddressText || 'Location not found',
              locationInfo: null,
              lockedDates: [],
            };
          } else {
            return '';
          }
        });

        // Filter out the inactive listings
        const transformedData = transformedDataRaw.filter(item => item !== '');
  
        console.log("New Transformed Data: ", transformedData);
        setTransformedData(transformedData);
      } catch (error) {
        console.error('Error fetching listings:', error);
      }
    };
    
      useEffect(() => {
        fetchListings();
      }, []);
    
    return (
        <>
        <FloatingButtons/>
        <section className='cs-bg-dark py-4 cs-section'>
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <h1 className='fw-bold text-white'>Our Boats</h1>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col">
                    <ListingsWithFilters data={transformedData} columns={columns}/>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}
